export type CellState = {
    invalid?: boolean
    warning?: boolean
    displayValue?: string
}

export type CellValue = {
    columnIndex: number
    rowIndex: number
    values: string[]
    isHidden?: boolean
    cellState?: CellState
}

export type Field = {
    index: number
    type: string
    subTypes: string[]
    name: string
    availableValues: string[]
    userCanEdit?: boolean
}

export type Profile = {
    index: number
    cellValues: CellValue[] // Needs to match order of fields
}

export const patchProfileRowIndexes = (baseIndex: number) => (profile: Profile, index: number): Profile => ({
    ...profile,
    index: index + baseIndex,
    cellValues: profile.cellValues.map((cellValue) => ({...cellValue, rowIndex: index + baseIndex})),
})

export type Loading = {
    grid?: boolean
    deletingRowIndexes?: number[]
    addingRowIndexes?: number[]
    columnIndexes?: number[]
}
